module.exports = __webpack_public_path__ + "img/4.a1ef2bbc.jpg";